import { useMemo, useState } from "react";
import { FCX, SelectSingle } from "@datassential/platform-ui-lib";
import { HomeRankingTabEnum, RestaurantSegmentEnum } from "@enums";
import { useHomeTopChainsByNPS } from "@apiHooks/useHomeTopChainsByNPS";
import { useHomeChainsGrowthData } from "@apiHooks/useHomeChainsGrowthData";
import HomeSectionHeader from "@pages/Home/components/HomeSectionHeader";
import HomeSectionTitle from "@pages/Home/components/HomeSectionTitle";
import HomeSectionTabs from "@pages/Home/components/HomeSectionTabs";
import { HOME_TOP_TABS } from "@pages/Home/constants";
import HomeSectionLoader from "@pages/Home/components/HomeSectionLoader";
import HomePlacesTopChains from "./HomePlacesTopChains/HomePlacesTopChains";
import HomePlacesGrowingChains from "./HomePlacesGrowingChains/HomePlacesGrowingChains";
import { RESTAURANT_SEGMENTS } from "./constants";
import "./HomePlaces.styles.scss";
import useLocalStorageState from "@hooks/useLocalStorageState";

const HomePlaces: FCX = () => {
    const { data: topChainsByNPS, isLoading: isLoadingNPS } = useHomeTopChainsByNPS();
    const { data: topChainsByGrowth, isLoading: isLoadingGrowth } = useHomeChainsGrowthData();

    const [activeTab, setActiveTab] = useLocalStorageState<HomeRankingTabEnum>('home-places-tab', HomeRankingTabEnum.WHATS_TOP);
    const [selectedSegmentId, setSelectedSegmentId] = useLocalStorageState<RestaurantSegmentEnum>('home-places-segment', RestaurantSegmentEnum.ALL);

    const renderTabContent = useMemo(() => ({
        [HomeRankingTabEnum.WHATS_TOP]: (
            <HomePlacesTopChains selectedSegmentId={selectedSegmentId} data={topChainsByNPS} />
        ),
        [HomeRankingTabEnum.WHATS_GROWING]: (
            <HomePlacesGrowingChains selectedSegmentId={selectedSegmentId} data={topChainsByGrowth} />
        )
    }), [selectedSegmentId, topChainsByNPS, topChainsByGrowth]);

    const placesSegment = useMemo(() => RESTAURANT_SEGMENTS.filter(segment => segment.id !== RestaurantSegmentEnum.UPSCALE_CASUAL), []);

    return (
        <div className="Home__wrapper">
            <HomeSectionHeader>
                <div className="HomePlaces__header">
                    <HomeSectionTitle>Places</HomeSectionTitle>
                    <SelectSingle
                        className="no-rem HomePlaces__segment-select"
                        value={selectedSegmentId}
                        setValue={setSelectedSegmentId}
                        options={placesSegment}
                        dropdownProps={{
                            place: "bottom-start",
                        }}
                    />
                </div>
                <HomeSectionTabs
                    data={HOME_TOP_TABS}
                    activeTabId={activeTab}
                    onItemClick={(id) => setActiveTab(id as HomeRankingTabEnum)}
                />
            </HomeSectionHeader>
            <div className="Home__sub-wrapper min-height">
                {isLoadingNPS || isLoadingGrowth ? (
                    <HomeSectionLoader />
                ) : (
                    renderTabContent[activeTab]
                )}
            </div>
        </div>
    );
}

export default HomePlaces;